export default "__VITE_ASSET__CDB0no0q__"